import { useState } from 'react';

export default function BlogNewsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setEmail('');
      setTimeout(() => setIsSuccess(false), 3000);
    }, 1000);
  };

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background cream gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-cream-100 via-cream-50 to-gold-50"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-64 h-64 bg-gold-200 rounded-full blur-3xl opacity-20"></div>
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-gold-300 rounded-full blur-3xl opacity-15"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-cream-50 border border-gold-200/60 rounded-3xl p-10 md:p-16 relative overflow-hidden">
            {/* Golden accent line */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-gold-400 via-gold-300 to-gold-500"></div>
            
            <div className="text-center">
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-gold-500 to-gold-700 rounded-2xl mb-6">
                <i className="ri-mail-line text-3xl text-white"></i>
              </div>

              {/* Title */}
              <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-charcoal-800 mb-4">
                Receba Novos Artigos no Seu{' '}
                <span className="italic text-gold-600">
                  E-mail
                </span>
              </h2>

              {/* Description */}
              <p className="text-base text-charcoal-500 mb-8 max-w-2xl mx-auto leading-relaxed font-light">
                Inscreva-se na nossa newsletter e receba semanalmente conteúdos exclusivos sobre autoconhecimento, transformação pessoal e práticas de gratidão.
              </p>

              {/* Form */}
              <form onSubmit={handleSubmit} className="max-w-xl mx-auto">
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="flex-1 relative">
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center justify-center w-5 h-5">
                      <i className="ri-mail-line text-lg text-gold-400"></i>
                    </div>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Seu melhor e-mail"
                      required
                      className="w-full pl-12 pr-4 py-4 border-2 border-gold-200 rounded-xl focus:border-gold-500 focus:outline-none text-charcoal-700 placeholder-charcoal-400 bg-white transition-colors text-sm"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={isSubmitting || isSuccess}
                    className="px-8 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-white font-semibold rounded-xl hover:from-gold-600 hover:to-gold-800 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer tracking-wide"
                  >
                    {isSubmitting ? (
                      <span className="flex items-center gap-2">
                        <i className="ri-loader-4-line animate-spin"></i>
                        Inscrevendo...
                      </span>
                    ) : isSuccess ? (
                      <span className="flex items-center gap-2">
                        <i className="ri-check-line"></i>
                        Inscrito!
                      </span>
                    ) : (
                      'Inscrever-se'
                    )}
                  </button>
                </div>
              </form>

              {/* Trust badges */}
              <div className="flex items-center justify-center gap-6 mt-8 text-sm text-charcoal-400">
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-gold-500"></i>
                  <span className="whitespace-nowrap">100% seguro</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-mail-check-line text-gold-500"></i>
                  <span className="whitespace-nowrap">Sem spam</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-close-circle-line text-gold-500"></i>
                  <span className="whitespace-nowrap">Cancele quando quiser</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
